module.exports = __webpack_public_path__ + "static/media/exam-fail.c081a865.svg";